export class DatasetModel {
  hotel_id: number;
  reason_type: string;
  reason_id: number;
  reason_line_id: number;
  main: string;
  sub: string;
  section_id: number;
  item: string;
  item_id: number;
  product: string;
  date: Date;
  profile_id: number;
  profile_name: string;
  rating: number;
  point: number;
  price: number;
  worker: string;
  status: string;
  duration: number;
  month: number;
  week: number;
  hotel_chain: string;
  hotel: string;
  language: string;
}
